import Shader from './Shader';
import * as Uniform from '../Uniform';
import FRAG_SATURATION from './Fragment/saturation.frag';

export default class SaturationShader extends Shader {
	public u_saturation:Uniform.Uniform1f = new Uniform.Uniform1f(0.0);

	public frag = ():string => FRAG_SATURATION;
}